import useUiuxStore from "src/store/useUiuxStore";
import { showWarning } from "src/utils/toast/toastUtil";
import { validateItemAccount, restoreOriginalValues } from "../Util_KSK2120_R01";
import { KSK2120_R01Dto } from "../Dto_KSK2120_R01";

interface UseKSK2120_R01ModalProps {
	updateKSK2120_R01List: (index: number, data: KSK2120_R01Dto) => void;
	gridRef: any;
	KSK2120_R01List: KSK2120_R01Dto[];
}

export function useKSK2120_R01Modal({ updateKSK2120_R01List, gridRef, KSK2120_R01List }: UseKSK2120_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = () => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	};

	const settingCodeSearchModalProps = (
		category: string,
		search: string,
		isInfo: boolean,
		handleFoucsId: string,
		originalData: KSK2120_R01Dto,
		valueIndex: number,
	) => {
		const handleClear = () => {
			const updateData: Partial<KSK2120_R01Dto> = {
				...originalData,
				lotNo: '',
				lotQty: 0,
				isModified: originalData.inserted ? false : true,
			};

			updateKSK2120_R01List(valueIndex, updateData as KSK2120_R01Dto);
			handlePopupClose();
		};

		setCodeSearchModalProps({
			category,
			search,
			formName: 'KSK2120_R01',
			isInfo,
			handleFoucsId,
			extraFilter: {
				workplaceCd: originalData.workplaceCd || "all",
				itemCd: originalData.childItemcd || ""
			},
			onClear: handleClear,
			onConfirm: (data: any) => {
				const updateData: Partial<KSK2120_R01Dto> = {
					...originalData,
					lotNo: data.lotNo,
					lotQty: data.lotQty,
					isModified: originalData.inserted ? false : true,
				};

				const currentRow = KSK2120_R01List.find(item => item.valueIndex === valueIndex);
				if (currentRow && data) {
					updateKSK2120_R01List(valueIndex, {
						...currentRow,
						...updateData,
						isModified: true
					});
				}
				setTimeout(() => {
					const api = gridRef.current?.api;
					if (!api) return;
				}, 0);
			},
			wrapperOption: {
				size: 'md',
				defaultWidth: 900,
				overlay: true
			},
		});
	};

	return { settingCodeSearchModalProps, handlePopupClose };
}
